module.exports = __webpack_public_path__ + "static/langojango-turkish-language-phrasebook-794256bb47929fe6893e53ccb881f590.png";